var $ = require('jquery');
var data = require('hudl-base').data;

var hudl = data.raw().hudl;

// hac - wrap it so it's also a plug-in
$.fn.truncateKeepFileExtension = function (size) {
    return this.each(function () {
        var $this = $(this);
        $this.text(hudl.Files.truncateKeepFileExtension($this.text(), size));
    });
};

hudl.Files = hudl.Files || {};

// hac - truncate file names while keeping the extension
var truncateFilename = function (fileName, size) {

    if (fileName === '' || fileName === null || size > fileName.length || size === 0) {
        return fileName;
    }

    var extIndex = fileName.lastIndexOf('.');
    // does not have an extension just truncate it as-is
    if (extIndex == -1) {
        return fileName.substring(0, size);
    } else {
        // get the extension without the dot e.g. 'jpg'
        var resExt = fileName.substr(extIndex + 1, fileName.length - extIndex);
        var resSize = size - resExt.length - 3;
        // strip out the extension
        var resFileName = fileName.replace(resExt, '').substr(0, resSize) + '...' + resExt;
        return resFileName;
    }

};

module.exports = {
    truncateFilename: truncateFilename
};
